import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const LocationOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fill="#4B4F54" d="M12 2.265c3.87 0 7 3.13 7 7 0 4.17-4.42 9.92-6.23 12.11-.4.48-1.13.48-1.53 0C9.42 19.185 5 13.435 5 9.265c0-3.87 3.13-7 7-7zm0 2c-2.765 0-5 2.235-5 5 0 2.384 1.974 5.963 4.69 9.476l.313.399.05-.063c2.774-3.535 4.816-7.123 4.94-9.578L17 9.265c0-2.765-2.235-5-5-5zm0 2.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5z" />
  </SvgIcon>
);
